import React from 'react';
import { isAtlaskitSelectUpgradeEnabled } from 'feature-flags';
import LabelIcon from '@atlaskit/icon/glyph/label';
import { Box, xcss } from '@atlaskit/primitives';
import { FieldSingleSelect, FieldSingleSelectNew } from '@atlassian/help-center-common-component/form-select';
import { ExperienceSuccess } from '@atlassian/ufo';
import type { FieldFormProps } from '../../types';
import { entitlementPickerLoadExperience } from '../experiences';
import type { Option } from '../types';

export interface Props extends Omit<FieldFormProps<string>, 'onChange'> {
    onChange: (value: Option | null, notFromUserInteraction?: boolean) => void;
    isLoading: boolean;
    selectedEntitlement: Option | null;
    entitlements: Option[];
}

const renderOption = (option: { label: string; value: string }) => (
    <Box xcss={optionStyles}>
        <Box xcss={iconContainerStyles}>
            <LabelIcon size="small" label="" />
        </Box>

        {option.label}
    </Box>
);

export const EntitlementPickerDumb = (props: Props) => {
    const { isLoading, entitlements, selectedEntitlement, ...fieldProps } = props;

    return (
        <>
            {!isLoading && <ExperienceSuccess experience={entitlementPickerLoadExperience} />}
            {isAtlaskitSelectUpgradeEnabled() ? (
                <FieldSingleSelectNew
                    {...fieldProps}
                    actionSubjectId="entitlementPicker"
                    value={selectedEntitlement}
                    options={entitlements}
                    formatOptionLabel={renderOption}
                    isDisabled={isLoading || props.disabled}
                    isLoading={isLoading}
                    isClearable
                />
            ) : (
                <FieldSingleSelect
                    {...fieldProps}
                    actionSubjectId="entitlementPicker"
                    value={selectedEntitlement}
                    options={entitlements}
                    formatOptionLabel={renderOption}
                    isDisabled={isLoading || props.disabled}
                    isLoading={isLoading}
                    isClearable
                />
            )}
        </>
    );
};

const optionStyles = xcss({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
});

const iconContainerStyles = xcss({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.050',
    padding: 'space.025',
});
